import ExampleSaveButton from '../example-buttons/ExampleSaveButton.vue';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';
import ExampleBackButton from '../example-buttons/ExampleBackButton.vue';

# Editing Queues

## <v-icon>mdi-rename-box</v-icon> Details

### Name

This is where you can change the name of the Queue.

### Description

This is where you can change the description of the Queue.

## <v-icon>mdi-motion-play-outline</v-icon> Play Conditions

Change the Play Conditions for this Queue.

Note: If this Queue is not enabled, and you play a Scene from the Queue or the Queue itself. Once the Scene has played it will play the Queue in the first slot. (Not the last playing Queue). If this Queue is the first slot, then it will play the second etc.

## <v-icon>mdi-filter-plus</v-icon> Asset Ingest

This is where you can set the Assets to Ingest. This works on Tags, click the Tag or Tags you wish to automatically ingest into this Queue.

## <v-icon>mdi-debug-step-over</v-icon> Overrides

{/* Editor Note */}
{/* Currently broken? Not Modal appears when clicking + */}

{/* Is this not the same as Play Conditions? */}

## <v-icon>mdi-star-shooting</v-icon> Domination Mode

This is where you can select the Domination Mode for this Queue.

Domination forces this Queue live when it's play conditions are valid.

- Disabled (doesn't automatically go live)
- Interrupt (plays straight away)
- Play Next (plays after the currently playing Scene finishes)

## <v-icon>mdi-share-all</v-icon> Triggers

**Note:** Triggers are a new feature, and are currently limited to what Triggers are available.

Triggers allow you to do various actions when this queue plays.

This can be used for triggering all Frames to display the same Scene when a Trigger has been met.

## Saving Changes

Click <ExampleSaveButton /> (bottom right) to save your changes.

## Deleting a Queue

Click <ExampleDeleteButton />, a confirmation box will appear.

Click <ExampleBackButton /> to Cancel or <ExampleDeleteButton /> delete the Queue.
